import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import {
  cappelloMutuiApi,
  cappelloPrestitiApi,
  cappelloCessioniApi,
} from '../../../services/api/cappelloparlante/cappelloparlante';
import CappelloParlanteSection from './components/CappelloParlanteSection';

const CappelloParlantePage = () => (
  <Box>
    <Box px={4} pt={4} pb={2} gap={1} display="flex" alignItems="center">
      <AutoFixHighIcon fontSize="large" />
      <Typography variant="h4" fontWeight="bold">
        Cappello parlante
      </Typography>
    </Box>

    <Box px={4} pb={4} display="flex" flexDirection="column" gap={2}>
      <CappelloParlanteSection title="Mutui" api={cappelloMutuiApi} defaultExpanded />
      <CappelloParlanteSection title="Prestiti" api={cappelloPrestitiApi} />
      <CappelloParlanteSection title="Cessione del Quinto" api={cappelloCessioniApi} />
    </Box>
  </Box>
);

export default CappelloParlantePage;
